<template>
  <div id="app">
    <div class="xq_top">
      <img class="img" @click="xqesc" src="../../static/images/esc.png" />
      <p @click="xqesc">{{pickda[pickxb].fh}}</p>
      <span>{{pickda[pickxb].ddxq}}</span>
    </div>
    <div style="width:100%;padding-top: 1.1rem;background: #f7f7f7;"></div>
    <div class="ddh">
      <div class="on">{{pickda[pickxb].ddh}}</div>
      <div>{{sheet.SheetID}}</div>
      <div class="on">{{pickda[pickxb].xdsj}}</div>
      <div>{{sheet.OpTime}}</div>
      <div class="posers" v-if="sheet.SheetState!=0">
        <div class="on">{{Foodlist[pickxb].on1}}</div>
        <div>{{sheet.OrderMen}}</div>
        <div class="on">{{Foodlist[pickxb].on2}}</div>
        <div>{{sheet.OrderPhone}}</div>
        <div v-if="sheet.SheetState==3"  class="on">{{Foodlist[pickxb].on3}}</div>
        <div v-if="sheet.SheetState==3" >{{sheet.OrderAddress}}</div>

        <div v-if="sheet.SheetState==3" class="on">{{Foodlist[pickxb].on4}}</div>
        <div v-if="sheet.SheetState==3" >{{sheet.PostCode}}</div>

        <div v-if="sheet.SheetState==4" class="on">{{Foodlist[pickxb].on5}}</div>
        <div v-if="sheet.SheetState==3" class="on">{{Foodlist[pickxb].on6}}</div>
        <div v-if="sheet.SheetState==3" >{{sheet.CompleteTime}}</div><!--时间未做-->
        <div v-if="sheet.SheetState==4" >{{sheet.ToshopTime}}</div><!--时间未做-->
      </div>

    </div>
    <div style="width:100%;background: #f7f7f7;height: .2rem;"></div>
    <div class="butt">
      <div class="spxx">{{pickda[pickxb].spxx}}</div>
      <div style="width:100%;background: #f7f7f7;height: .04rem;"></div>
      <div v-for="(item,index) in list" class="clas">
        <div class="left">
          <img @error="imageLoad2(index)" ref="xqimg" :src="$lujin+'/Data/'+ShopID+'/GoodsPic/'+item.GoodsID+'.jpg'" />
        </div>
        <div class="rigth">
          <div v-if="WXLangGoodsxb==0" >{{item.Goods}}</div>
          <div v-if="WXLangGoodsxb==1" >{{item.TwoGoods}}</div>
          <div v-if="WXLangGoodsxb==2" >{{item.ThreeGoods}}</div>
          <div>{{item.OpItemsTime}}</div>
          <div style="font-size:.24rem;">{{pickda[pickxb].bz}}：{{item.CustomReamrk}}</div>
          <div>
            <span style="color:#000;">{{item.SellPrice.toFixed(2)}}</span>
            <span style="color:#999;">×</span>
            <span style="color:#000;">{{item.Qua}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        pickxb: 0,
        sheet:{},
        pickindex:0,
        WXLangGoodsxb:0,
        SheetID: 0,
        DeskID:0,
        Phone:0,
        ShopID: 0,
        list: [{
          SheetID: 0,
          GoodsID: 1001,
          SellPrice: 0
        }],
        pickda:[
          {fh:"返回",ddxq:"订单详情",xdsj:"下单时间",ddh:"订单号",spxx:'商品信息',bz:'备注'},
          {fh:"返回",ddxq:"訂單詳情",xdsj:"下單時間",ddh:"訂單號",spxx:'菜品詳細',bz:'備註'},
          {fh:"Back",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"إرجاع",ddxq:"تفاصيل الطلب",xdsj:"وقت الطلب",ddh:"رقم الطلب",spxx:'معلومات المنتج',bz:'ملاحظة'},
          {fh:"ដកថយ",ddxq:"ព័ត៌មានលម្អិត",xdsj:"ពេលវេលាបញ្ជា",ddh:"លេខ​លំដាប់",spxx:'ព័ត៌មាន​អំពី​ផលិតផល',bz:'ចំណាំ'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"Terug",ddxq:"Bestel details",xdsj:"Bestel tijd",ddh:"Bestelling nummer",spxx:'Productdetails',bz:'Opmerking'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"dettagli dell'ordine",xdsj:"dettagli dell'ordine",ddh:"numero d'ordine",spxx:'Informazioni sui prodotti',bz:'Nota'},
          {fh:"戻り",ddxq:"情報",xdsj:"オーダー時間",ddh:"伝票番号",spxx:'商品情報',bz:'備考'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"Zurück",ddxq:"Kasse",xdsj:"Bestellzeit",ddh:"Bestellnummer",spxx:'Produktinformationen',bz:'Bemerkung'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"details",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"wrócić",ddxq:"zamówienia",xdsj:"Czas na złożenie zamówienia",ddh:"Numer zamówienia",spxx:'Informacje o produkcie',bz:'uwaga'},
          {fh:"wrócić",ddxq:"zamówienia",xdsj:"Czas na złożenie zamówienia",ddh:"Numer zamówienia",spxx:'Informacje o produkcie',bz:'uwaga'},
          {fh:"wrócić",ddxq:"zamówienia",xdsj:"Czas na złożenie zamówienia",ddh:"Numer zamówienia",spxx:'Informacje o produkcie',bz:'uwaga'},
          {fh:"กลับ",ddxq:"รายละเอียดการสั่งซื้อ",xdsj:"เวลาสั่ง",ddh:"หมายเลขคำสั่งซื้อ",spxx:'ข้อมูลผลิตภัณฑ์',bz:'หมายเหตุ'},
          {fh:"απόδοση",ddxq:"Αποχώρηση",xdsj:"Ώρα παραγγελίας",ddh:"Αριθμός παραγγελίας",spxx:'Πληροφορίες προϊόντος',bz:'Παρατήρηση'},
          {fh:"Nazaj",ddxq:"Podrobnosti o naročilu",xdsj:"Čas naročila",ddh:"Številka naročila",spxx:'Informacije o izdelku',bz:'Opomba'},
          {fh:"Back",ddxq:"Order Details",xdsj:"Order Time",ddh:"Order №",spxx:"Commodity information",bz:"Notes"},
		  {fh:"qayıtmaq",ddxq:"Kassa",xdsj:"Sifariş vaxtı",ddh:"Sifariş nömrəsi",spxx:"Məhsul Məlumatı",bz:"Qeyd"},
		  {fh:"ပြန်လည်",ddxq:"စာရင်းချုပ်",xdsj:"စာရင်းချိန်",ddh:"စာရင်းနံပါတ်",spxx:"ကုန်ပစ္စည်းသတင်းအချက်အလက်",bz:"မှတ်ချက်"},
		  {fh:"Geri Dön",ddxq:"Sipariş Detayı",xdsj:"Sipariş Zamanı",ddh:"Sipariş Numarası",spxx:"Ürün Bilgisi",bz:"Not"},
		  {fh:"буцах",ddxq:"Захиалгын дэлгэрэнгү",xdsj:"Захиалсан цаг",ddh:"Захиалгын дугаар",spxx:"Бүтээгдэхүүний мэдээ",bz:"Тайлбар"},
        ],
        Foodlist:[
          {on1:"姓名",on2:"电话",on3:"地址",on4:"邮编",on5:"到店时间",on6:"送达时间"},
          {on1:"姓名",on2:"電話",on3:"地址",on4:"邮编",on5:"預計取餐時間",on6:"送達時間"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Schedule Pick Up Time",on6:"Time of delivery"},
          {on1:"اسم",on2:"هاتف",on3:"تبوك",on4:"الرمز البريدي",on5:"حان الوقت للمتجر",on6:"موعد التسليم"},
          {on1:"ឈ្មោះ",on2:"ទូរស័ព្ទ",on3:"អាសយដ្ឋាន",on4:"លេខកូដប្រៃសណីយ៍",on5:"ពេលវេលាមកដល់",on6:"ពេលវេលាដឹកជញ្ជូន"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Naam",on2:"Telefoonnummer",on3:"Adres",on4:"Postcode",on5:"Aankomsttijd in de zaak",on6:"Aankomsttijd"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"お名前",on2:"お電話番号",on3:"ご住所",on4:"郵便番号",on5:"到着時間",on6:"配達時間"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telefon",on3:"Adresse",on4:"Postleitzahl (PLZ)",on5:"Ankunftszeit im Restaurant",on6:"Lieferzeit"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"Name",on2:"Telephone",on3:"Address",on4:"Zip code",on5:"Arrival time in the store",on6:"Time of delivery"},
          {on1:"ชื่อ",on2:"โทรศัพท์",on3:"ที่อยู่",on4:"รหัสไปรษณีย์",on5:"เวลามาถึง",on6:"เวลาจัดส่ง"},
          {on1:"Ονομα",on2:"Τηλέφωνο",on3:"διεύθυνση",on4:"ταχυδρομικός κώδικας",on5:"Ώρα άφιξης",on6:"Χρόνος παράδοσης"},
          {on1:"Ime in priimek",on2:"GSM",on3:"Naslov",on4:"Poštna št.",on5:"Čas prihoda",on6:"Čas dostave"},
          {on1:"Name and Surname",on2:"Cell Phone",on3:"Address",on4:"Postcode",on5:"Arrival Time",on6:"Delivery Time"},
		  {on1:"Ad",on2:"Telefon",on3:"Adres",on4:"Posta Kodu",on5:"Mağaza Zamanı",on6:"Teslim Zamanı"},
		  {on1:"Name and Surname",on2:"Cell Phone",on3:"Address",on4:"Postcode",on5:"Arrival Time",on6:"Delivery Time"},
		  {on1:"Ad",on2:"Telefon",on3:"Adres",on4:"Posta Kodu",on5:"Mağaza Zamanı",on6:"Teslim Zamanı"},
		  {on1:"Нэр",on2:"Утас",on3:"Хаяг",on4:"Шуудангийн код",on5:"Ирэх цаг",on6:"Хүргэлтийн хугацаа"},
        ]
      }
    },
    mounted() {
      var that = this
      if (localStorage.getItem(this.$route.query.Shopid+'pickxb'))
        this.pickxb = localStorage.getItem(this.$route.query.Shopid+'pickxb');
      if(localStorage.getItem(this.$route.query.Shopid+'pickindex'))//判断语音下标
        this.pickindex=localStorage.getItem(this.$route.query.Shopid+'pickindex')
      if(localStorage.getItem(this.$route.query.Shopid+'WXLangGoodsxb'))//判断语音下标
          this.WXLangGoodsxb=localStorage.getItem(this.$route.query.Shopid+'WXLangGoodsxb')
      this.ShopID = this.$route.query.Shopid
      this.DeskID = this.$route.query.DeskID
      this.Phone = this.$route.query.Phone
      this.axios.get(this.$lujin + "/api/Default/Sheetxq?SheetID=" + this.$route.query.SheetID + "&ShopID=" + this.$route.query.Shopid)
        .then((res)=>{
          console.log(res)
          console.log(res.data.Data[0])
          var pos=res.data.Data[0]
          var zt=""
          for(var i in pos.OpTime){
            if(i>10){
              zt+=pos.OpTime[i]
            }
          }
          pos.OpTime=zt
          that.sheet=pos
        })

      this.axios.get(this.$lujin + "/api/Default/SheetItems?SheetID=" + this.$route.query.SheetID + "&ShopID=" + this.$route.query.Shopid)
        .then((res) => {
          console.log(res)
          console.log(res.data.Data)
          var sz = res.data.Data
          for (var i in sz) {
            sz[i].OpItemsTime = sz[i].OpItemsTime.replace('T', ' ');
            sz[i].OpItemsTime = sz[i].OpItemsTime.slice(10, 19)
          }
          that.list = sz
        })
    },
    methods: {
      imageLoad2(index) {
        this.$refs.xqimg[index].src = '../static/images/zwtp.png'
        //console.log(this.$refs.xqimg[index])
      },
      xqesc: function() {
        this.$router.go(-1);
      },
    },
  }
</script>



<style scoped>
  .ddh .posers{width:100%;}
  .ddh .on{font-weight: bold;}
  .clas {
    border-bottom: 2px solid #f7f7f7;
  }

  .rigth {
    margin: .26rem 0 0 .2rem;
    text-align: left;
    align-items: center;
    text-align: left;
    text-justify: newspaper;
    word-break: break-all;
  }

  .clas {
    display: flex;
  }

  .spxx {
    text-align: left;
    width: 90%;
    margin: 0 auto;
    line-height: 1rem;
  }

  .butt {
    font-size: .32rem;
    font-weight: bold;
  }

  .left img {
    margin: .26rem 0 0 .26rem;
    width: 3rem;
    position: relative;
  }

  .ddh {
    font-size: .28rem;
    background: #fff;
    padding: .1rem 0 .1rem 0;
  }

  .ddh div {
    width: 90%;
    margin: 0 auto;
    text-align: left;
    line-height: .48rem;
  }

  .clear::after {
    content: ;
    clear: both;
  }

  .dingdan {
    background: #fff;
    position: fixed;
    top: .91rem;
    left: 0;
    right: 0;
  }

  .dingdan ul {
    display: flex;
  }

  .dingdan ul li {
    font-size: .32rem;
    width: 25%;
    padding: .1rem;
  }

  .dingdan ul li.on {
    color: orange;
    border-bottom: 1px solid orange;
  }

  .ddlist {
    background: #f7f7f7;
    float: left;
    width: 100%;
    height: 100%;
    padding-top: 1.64rem;
  }

  .ddlist>div {
    width: 90%;
    margin: .3rem auto 0 auto;
    background: #fff;
    border-radius: .1rem;
  }

  .ddlist>div .top p {
    height: .4rem;
    margin-top: .2rem;
    border-radius: .4rem;
    padding: 0 .1rem;
  }

  .ddlist>div .top p.on1 {
    border: 1px solid chartreuse;
    color: chartreuse;
  }

  .ddlist>div .top p.on2 {
    border: 1px solid orange;
    color: orange;
  }

  .ddlist>div .top p.on3 {
    border: 1px solid #999;
    color: #999;
  }

  .ddlist>div .top span {
    line-height: .8rem;
  }

  .ddlist>div .top {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    height: .8rem;
    border-bottom: 1px solid #eee;
  }

  .ddlist div span,
  .ddlist div p {
    font-size: .28rem;
    display: block;
  }

  .butlist {
    display: flex;
    line-height: .8rem;
    width: 90%;
    margin: 0 auto;
    justify-content: space-between;
  }

  .butlist span {
    font-size: .32rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/qxfood.vue